"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginPage = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var layout_1 = require("../_shared/components/layout");
var LoginForm_1 = require("./partials/LoginForm");
require("./LoginPage.scss");
var LoginPage = /** @class */ (function (_super) {
    __extends(LoginPage, _super);
    function LoginPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoginPage.prototype.render = function () {
        return (React.createElement(layout_1.Page, { id: "login-page" },
            React.createElement(layout_1.Column, null,
                React.createElement(layout_1.Column, { alignItems: "center", justifyContent: "center" },
                    React.createElement("div", { className: "login-container" },
                        React.createElement(layout_1.Wrapper, { padding: "24px" },
                            React.createElement(layout_1.Row, { justifyContent: "center" },
                                React.createElement("i", { className: "material-icons login-icon" }, "pin_drop")),
                            React.createElement(layout_1.Margin, { marginVertical: "36px" }),
                            React.createElement(LoginForm_1.default, null)))))));
    };
    return LoginPage;
}(React.Component));
exports.LoginPage = LoginPage;
var Container = (0, react_redux_1.connect)()(LoginPage);
exports.default = Container;
